import React from 'react';
import translateString from '../utils/Locales';

let t = translateString;

export default class RotateDeviceWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = { }; 
    }

    render() {
        return(
            <div style={{ height: '100%', width: '100%', textAlign: 'center' }}>
                <div>
                    <img alt="" src={ require('../images/rotate_phone.gif' )} style={{ height: 200, width: 200, marginTop: '50%', transform: 'translateY(-50%)' }} />
                    <p style={{ fontFamily: 'Teko', fontSize: 20, color: 'black', textAlign: 'center', fontWeight: 'bold', marginTop: -100, maxWidth: '85%', marginLeft: '7.5%' }}>{t('ruota_info')}</p>
                </div>
            </div>
        );
    }
}